import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { sizes, media } from 'src/styles/Media.styled';
import {
    HeaderGridContainer,
    HeaderNameTextGrid,
    HeaderOrderDefaultTextGrid,
    HeaderAddressTextGrid,
    AccountNameGrid,
    OrderDetailTabBodyContainer,
    BodyGridContainer,
    AddressGrid,
    AccountName,
    AccountNumber,
    AccountDefaultDesktop,
    AccountDefaultMobile,
    Address,
    OrderDefaultsGrid,
    OrderContent,
    Od,
    Footer,
} from './index.styled';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { TextBold } from 'src/common/components/filter/Filters.styled.jsx';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import NonTissueItemIcon from 'src/assets/images/NonTissueItemIcon.svg';
import TissueItemIcon from 'src/assets/images/TissueItemIcon.svg';
import check from 'src/assets/images/MDI-check.svg';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges';
import {
    getAccountDetailss,
    setUnsavedChange,
    setShipToAddressEdit,
} from 'src/pages/more/redux/actions';
import { accountNumberZeroTrimmer, isIpad } from 'src/utils/util';
import {
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import { BLACK_FONT_COLOR, FONT_FAMILY_REGULAR, SEMANTIC_TEXT_PX } from '../../../../../../styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ShipToAddress = ({
    onSave,
    shipToAddress,
    setShipToAddressDetails,
    setSelectedSTAArray,
    account,
    employeeRole,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isCancel, setisCancel] = useState(false);
    // const [isInitial, setIsInitial] = useState(true);
    const [checkboxValues, setCheckboxValues] = useState([]);
    const [, setSelectedIndex] = useState(0);
    const [discard, setDiscard] = useState(false);
    // const width = window.innerWidth;
    // const height = window.innerHeight;
    const onEdit = () => {
        dispatch(setShipToAddressEdit(true));
        // setisEdit(true);
    };
    const [width, setWidth] = useState(window.orientation);
    useEffectWithErrorLogging(() => {
        if (discard === true) {
            setShipToAddressDetails(shipToAddress);
        }
    }, [discard]);

    useEffectWithErrorLogging(() => {
        const defaultCheckBoxValues = [
            {
                label: 'Tissue',
                value: 'Tissue',
                checkedValue: 'isTissueSelected',
                blockedValue: 'isTissueBlocked',
            },
            {
                label: countryISOCode == 'US' ? 'Non Tissue' : 'Default',
                value: countryISOCode == 'US' ? 'Non Tissue' : 'Default',
                checkedValue: 'isNonTissueSelected',
                blockedValue: 'isNonTissueBlocked',
            },
            {
                label: 'UNiD Rod',
                value: 'UNiD Rod',
                checkedValue: 'isUnidRodSelected',
                blockedValue: 'isUnidRodBlocked',
            },
        ];
        setCheckboxValues(defaultCheckBoxValues);
        dispatch(setUnsavedChange(false));
    }, []);

    const onCancel = () => {
        // setisEdit(false);
        setisCancel(true);
    };

    const handleChange = (e, gridIndex) => {
        // eslint-disable-next-line no-debugger
        setSelectedIndex(gridIndex);
        let itemIndex = '';
        let checkedItems = checkboxValues;
        let shipToAddressValues = [...shipToAddress];
        shipToAddress &&
            shipToAddress.map((staData, index) => {
                let newIndex = index;
                if (index === gridIndex) {
                    checkboxValues.map((item, index) => {
                        itemIndex = checkedItems.findIndex(
                            (check) => check.label == e.target.name
                        );

                        if (itemIndex >= 0) {
                            shipToAddressValues[gridIndex][
                                checkedItems[itemIndex].checkedValue
                            ] = e.target.checked;
                        } else {
                            checkedItems[index].isChecked = false;
                        }
                    });
                } else {
                    checkboxValues.map(() => {
                        itemIndex = checkedItems.findIndex(
                            (check) => check.label == e.target.name
                        );
                        if (e.target.checked === true) {
                            if (itemIndex >= 0) {
                                shipToAddressValues[newIndex][
                                    checkedItems[itemIndex].checkedValue
                                ] = false;
                            }
                        }
                    });
                }
            });
        setShipToAddressDetails(shipToAddressValues);
        // let selectedArray = [];
        // shipToAddressValues.map((shipValues) => {
        //     const selectedValues = {
        //         defaultNontissueShipTo: shipValues.isNonTissueSelected || false,
        //         defaultTissueShipTo: shipValues.isTissueSelected || false,
        //         defaultUnidRodShipTo: shipValues.isUnidRodSelected || false,
        //         sapAccountId: shipValues.accountNumber,
        //     };
        //     console.log(selectedValues, 'selectedValues');
        //     selectedArray.push(selectedValues);

        // });
        const selectedArray = shipToAddressValues.map((shipValues) => ({
            defaultNontissueShipTo: shipValues.isNonTissueSelected || false,
            defaultTissueShipTo: shipValues.isTissueSelected || false,
            defaultUnidRodShipTo: shipValues.isUnidRodSelected || false,
            sapAccountId: shipValues.accountNumber,
        }));

        // console.log(selectedArray, 'selectedArray');
        setSelectedSTAArray(selectedArray);
        setCheckboxValues([...checkedItems]);
        // setChecked([...checkedItems]);
        dispatch(setUnsavedChange(true));
    };

    //setNonTissueChecked(value);
    // setIsInitial(false);
    // console.log('isInital' + isInitial);
    // setNonTissueChecked(e.target.checked);
    // console.log(
    //     'Tissue' +
    //         tissueChecked +
    //         'NonTissue' +
    //         nonTissueChecked +
    //         'UnidRod' +
    //         unidRodChecked
    // );
    //     let checkedItems = che;

    // const { name, checked } = e.target;

    // props.inventoryDetails &&
    //     props.inventoryDetails.map((user, index) => {
    //         itemIndex = checkedItems.findIndex(
    //             (product) => product.cfn == e.target.name
    //         );

    //         console.log('itemIndexxxx', itemIndex);

    //         setCheckToggle(true);

    //         if (itemIndex >= 0) {
    //             checkedItems[itemIndex].isChecked = e.target.checked;
    //         } else {
    //             checkedItems[index].isChecked = false;
    //         }
    //     });

    // setChecked([...checkedItems]);

    // console.log('checkedItemssss', checkedItems);

    // selectedItemsCount(checkedItems);

    // handleSlectedItems(checkedItems);
    // };

    const handleDiscardChanges = () => {
        setisCancel(false);
        // setisEdit(false);
        dispatch(setShipToAddressEdit(false));
        setDiscard(true);
        dispatch(getAccountDetailss({ accountId: account.accountId }));
    };
    const handleSaveAndExit = () => {
        setisCancel(false);
    };
    const fromSettingsClose = () => {
        setisCancel(false);
    };

    const shipToAddressEdit = useSelector(
        (state) => state.accountReducer.shipToAddressEdit
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    useEffectWithErrorLogging(() => {
        const newAngle = window.orientation;

        setWidth(newAngle);
    }, [width, window.orientation]);

    return (
        <>
            <HeaderGridContainer
                container
                justifyContent={'space-between'}
                direction="row"
            >
                <HeaderNameTextGrid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    mobile={12}
                >
                    {t('accounts.accountList.accountName')}
                </HeaderNameTextGrid>
                <HeaderAddressTextGrid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    mobile={12}
                >
                    {t('accounts.shipToAddress.address')}
                </HeaderAddressTextGrid>
                <HeaderOrderDefaultTextGrid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    xl={4}
                    mobile={12}
                >
                    {t('accounts.shipToAddress.orderDefaults')}
                </HeaderOrderDefaultTextGrid>
            </HeaderGridContainer>
            <OrderDetailTabBodyContainer>
                {shipToAddress &&
                    shipToAddress.map((sta, index) => {
                        return (
                            <BodyGridContainer
                                container
                                direction="row"
                                key={index}
                            >
                                <AccountNameGrid
                                    item
                                    xs={12}
                                    sm={4}
                                    md={4}
                                    lg={4}
                                    xl={4}
                                    mobile={12}
                                    key="accountName"
                                    shipToAddressEdit={shipToAddressEdit}
                                >
                                    <AccountName>{sta.accountName}</AccountName>
                                    <AccountNumber>
                                        {t(
                                            'physicians.associatedAccount.account'
                                        )}
                                        {'  '}
                                        {accountNumberZeroTrimmer(
                                            sta.accountNumber
                                        )}
                                    </AccountNumber>
                                    {sta.orderType && (
                                        <AccountDefaultDesktop>
                                            <span style={{ display: 'flex' }}>
                                                <span
                                                    style={{ width: '100px' }}
                                                >
                                                    {(sta.orderType &&
                                                        sta.orderType.includes(
                                                            'User Default Non Tissue'
                                                        )) ||
                                                    sta.orderType.includes(
                                                        'User Default Tissue'
                                                    )
                                                        ? t(
                                                              'accounts.shipToAddress.userDefault'
                                                          )
                                                        : ''}
                                                    {'  '}
                                                </span>
                                                <span
                                                    style={{
                                                        marginLeft: '11px',
                                                        marginTop: '2px',
                                                    }}
                                                >
                                                    {sta.orderType &&
                                                    sta.orderType.includes(
                                                        'User Default Non Tissue'
                                                    ) &&
                                                    countryISOCode === 'US' ? (
                                                        <img
                                                            src={
                                                                NonTissueItemIcon
                                                            }
                                                            alt="NT"
                                                        />
                                                    ) : null}
                                                    {sta.orderType &&
                                                    sta.orderType.includes(
                                                        'User Default Tissue'
                                                    ) &&
                                                    countryISOCode === 'US' ? (
                                                        <img
                                                            src={TissueItemIcon}
                                                            alt="T"
                                                            style={{
                                                                marginLeft:
                                                                    sta.orderType.includes(
                                                                        'User Default Non Tissue'
                                                                    )
                                                                        ? '4px'
                                                                        : '0',
                                                            }}
                                                        />
                                                    ) : null}
                                                </span>
                                            </span>
                                            <span style={{ display: 'flex' }}>
                                                <span
                                                    style={{ width: '100px' }}
                                                >
                                                    {(sta.orderType &&
                                                        sta.orderType.includes(
                                                            'Account Default Non Tissue'
                                                        )) ||
                                                    sta.orderType.includes(
                                                        'Account Default Tissue'
                                                    )
                                                        ? t(
                                                              'accounts.shipToAddress.accountDefault'
                                                          )
                                                        : ''}
                                                    {'  '}
                                                </span>
                                                <span
                                                    style={{
                                                        marginLeft: '11px',
                                                        marginTop: '2px',
                                                    }}
                                                >
                                                    {sta.orderType &&
                                                    sta.orderType.includes(
                                                        'Account Default Non Tissue'
                                                    ) &&
                                                    countryISOCode == 'US' ? (
                                                        <img
                                                            src={
                                                                NonTissueItemIcon
                                                            }
                                                            alt="NT"
                                                        />
                                                    ) : null}
                                                    {sta.orderType &&
                                                    sta.orderType.includes(
                                                        'Account Default Tissue'
                                                    ) &&
                                                    countryISOCode == 'US' ? (
                                                        <img
                                                            style={{
                                                                marginLeft:
                                                                    sta.orderType.includes(
                                                                        'Account Default Non Tissue'
                                                                    )
                                                                        ? '4px'
                                                                        : '0',
                                                            }}
                                                            src={TissueItemIcon}
                                                            alt="T"
                                                        />
                                                    ) : null}
                                                </span>
                                            </span>
                                        </AccountDefaultDesktop>
                                    )}
                                </AccountNameGrid>
                                <AddressGrid
                                    item
                                    xs={12}
                                    sm={4}
                                    md={4}
                                    lg={4}
                                    xl={4}
                                    mobile={12}
                                    shipToAddressEdit={shipToAddressEdit}
                                >
                                    <Address>
                                        {/* {sta.address.line1}
                                        <br />
                                        {sta.address.line3}
                                        <br />
                                        {sta.address.postal}
                                        <br />
                                        {sta.address.region}
                                        <br />
                                        {sta.address.town}
                                        <br /> */}
                                        {sta?.address?.line3 ? (
                                            <>
                                                {sta?.address?.line3} <br></br>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {sta?.address?.line1 ? (
                                            <>
                                                {sta?.address?.line1} <br></br>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        <br></br>
                                        {sta?.address?.line2 ? (
                                            <>
                                                {sta?.address?.line2} <br></br>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {sta?.address?.town ? (
                                            <>
                                                {sta?.address?.town}
                                                {', '}
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {sta?.address?.region ? (
                                            <>{sta?.address?.region} </>
                                        ) : (
                                            ''
                                        )}
                                        {sta?.address?.postal ? (
                                            <>{sta?.address?.postal}</>
                                        ) : (
                                            ''
                                        )}
                                    </Address>
                                </AddressGrid>
                                <OrderDefaultsGrid
                                    item
                                    xs={12}
                                    sm={4}
                                    md={4}
                                    lg={4}
                                    xl={4}
                                    mobile={12}
                                    shipToAddressEdit={shipToAddressEdit}
                                >
                                    <Od>
                                        {t(
                                            'accounts.shipToAddress.orderDefaults'
                                        )}
                                        :
                                    </Od>
                                    {shipToAddressEdit ? (
                                        <>
                                            <OrderContent>
                                                {checkboxValues.map(
                                                    (checkbox) => {
                                                        if (
                                                            countryISOCode !==
                                                                'US' &&
                                                            (checkbox.value ==
                                                                'Tissue' ||
                                                                checkbox.value ==
                                                                    'UNiD Rod')
                                                        ) {
                                                            return null;
                                                        } else {
                                                            return (
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            'inline-flex',
                                                                    }}
                                                                    key={
                                                                        checkbox.value
                                                                    }
                                                                >
                                                                    <Checkbox
    name={checkbox.value}
    id={`accounts-shipToAddress-${checkbox.value.replace(/\s+/g, '')}-${index}-checkbox`}
    checked={
        sta[checkbox.checkedValue] ? true : false
    }
    disabled={
        sta[checkbox.blockedValue] ? true : false
    }
    onCheckboxSelectionChange={(e) =>
        handleChange(
            e,
            index,
            sta && sta.accountName
        )
    }
    labelStyleObj={{
        fontFamily: FONT_FAMILY_REGULAR,
        textAlign: 'left',
        fontSize: SEMANTIC_TEXT_PX,
        letterSpacing: '-0.12px',
        color: BLACK_FONT_COLOR,
        opacity: 1,
        paddingLeft: '5px',
    }}
/>
                                                                    <span
                                                                        style={{
                                                                            marginLeft:
                                                                                '7px',
                                                                        }}
                                                                    >
                                                                        {
                                                                            checkbox.label
                                                                        }
                                                                    </span>
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                )}
                                                {/*                                                
                                                <div
                                                    style={{
                                                        display: 'inline-flex',
                                                    }}
                                                    marginBottom="5px"
                                                >
                                                    <CustomCheckbox
                                                        style={{
                                                            border: '1px solid',
                                                        }}
                                                        value={tissueChecked}
                                                        checked={tissueChecked}
                                                        onCheckboxSelectionChange={(
                                                            e
                                                        ) =>
                                                            setTissueChecked(
                                                                e.target.checked
                                                            )
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            marginLeft: '7px',
                                                        }}
                                                    >
                                                        {
                                                            checkBoxValues[1]
                                                                .label
                                                        }
                                                    </span>
                                                </div>
                                                <div
                                                    style={{
                                                        display: 'inline-flex',
                                                    }}
                                                    marginBottom="5px"
                                                >
                                                    <CustomCheckbox
                                                        style={{
                                                            border: '1px solid',
                                                        }}
                                                        checked={unidRodChecked}
                                                        value={unidRodChecked}
                                                        onCheckboxSelectionChange={(
                                                            e
                                                        ) =>
                                                            setUnidRodChecked(
                                                                e.target.checked
                                                            )
                                                        }
                                                    />
                                                    <span
                                                        style={{
                                                            marginLeft: '7px',
                                                        }}
                                                    >
                                                        {
                                                            checkBoxValues[2]
                                                                .label
                                                        }
                                                    </span>
                                                </div> */}
                                            </OrderContent>
                                        </>
                                    ) : (
                                        <OrderContent>
                                            {sta.isTissueSelected ||
                                            sta.isNonTissueSelected ||
                                            sta.isUnidRodSelected ? (
                                                <>
                                                    {sta.isTissueSelected &&
                                                    countryISOCode === 'US' ? (
                                                        <div
                                                            style={{
                                                                width: '80px',
                                                            }}
                                                        >
                                                            <img
                                                                src={check}
                                                                alt="tick"
                                                                style={{
                                                                    marginBottom:
                                                                        '-7px',
                                                                }}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft:
                                                                        '7px',
                                                                }}
                                                            >
                                                                {t(
                                                                    'consignment.productType.type.tissue'
                                                                )}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            style={{
                                                                height: '20px',
                                                                width: '80px',
                                                            }}
                                                        ></div>
                                                    )}
                                                    {sta.isNonTissueSelected ? (
                                                        <div
                                                            style={{
                                                                width: '100px',
                                                            }}
                                                        >
                                                            <img
                                                                src={check}
                                                                alt="tick"
                                                                style={{
                                                                    marginBottom:
                                                                        '-7px',
                                                                }}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft:
                                                                        '7px',
                                                                }}
                                                            >
                                                                {countryISOCode ===
                                                                'US'
                                                                    ? t(
                                                                          'orders.orderTypes.nonTissue'
                                                                      )
                                                                    : t(
                                                                          'filter.defaultLabel'
                                                                      )}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            style={{
                                                                height: '20px',
                                                                width: '100px',
                                                            }}
                                                        ></div>
                                                    )}
                                                    {sta.isUnidRodSelected &&
                                                    countryISOCode === 'US' ? (
                                                        <div
                                                            style={{
                                                                width: '100px',
                                                            }}
                                                        >
                                                            <img
                                                                src={check}
                                                                alt="tick"
                                                                style={{
                                                                    marginBottom:
                                                                        '-7px',
                                                                }}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft:
                                                                        '7px',
                                                                }}
                                                            >
                                                                {t(
                                                                    'more.common.UNiDRod'
                                                                )}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            style={{
                                                                height: '20px',
                                                                width: '100px',
                                                            }}
                                                        ></div>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {t(
                                                        'accounts.shipToAddress.noneSelected'
                                                    )}
                                                </>
                                            )}
                                        </OrderContent>
                                    )}
                                    {sta.orderType && (
                                        <AccountDefaultMobile>
                                            <span style={{ display: 'flex' }}>
                                                <span
                                                    style={{ width: '100px' }}
                                                >
                                                    {(sta.orderType &&
                                                        sta.orderType.includes(
                                                            'User Default Non Tissue'
                                                        )) ||
                                                    sta.orderType.includes(
                                                        'User Default Tissue'
                                                    )
                                                        ? t(
                                                              'accounts.shipToAddress.userDefault'
                                                          )
                                                        : ''}
                                                    {'  '}
                                                </span>
                                                <span
                                                    style={{
                                                        margin: '1px 0 0 10px',
                                                    }}
                                                >
                                                    {sta.orderType &&
                                                    sta.orderType.includes(
                                                        'User Default Non Tissue'
                                                    ) ? (
                                                        <img
                                                            src={
                                                                NonTissueItemIcon
                                                            }
                                                            alt="NT"
                                                        />
                                                    ) : null}
                                                    {sta.orderType &&
                                                    sta.orderType.includes(
                                                        'User Default Tissue'
                                                    ) ? (
                                                        <img
                                                            src={TissueItemIcon}
                                                            alt="T"
                                                            style={{
                                                                marginLeft:
                                                                    sta.orderType.includes(
                                                                        'User Default Non Tissue'
                                                                    )
                                                                        ? '4px'
                                                                        : '0',
                                                            }}
                                                        />
                                                    ) : null}
                                                </span>
                                            </span>
                                            <span style={{ display: 'flex' }}>
                                                <span
                                                    style={{ width: '100px' }}
                                                >
                                                    {(sta.orderType &&
                                                        sta.orderType.includes(
                                                            'Account Default Non Tissue'
                                                        )) ||
                                                    sta.orderType.includes(
                                                        'Account Default Tissue'
                                                    )
                                                        ? t(
                                                              'accounts.shipToAddress.accountDefault'
                                                          )
                                                        : ''}
                                                    {'  '}
                                                </span>
                                                <span
                                                    style={{
                                                        margin: '1px 0 0 10px',
                                                    }}
                                                >
                                                    {sta.orderType &&
                                                    sta.orderType.includes(
                                                        'Account Default Non Tissue'
                                                    ) ? (
                                                        <img
                                                            src={
                                                                NonTissueItemIcon
                                                            }
                                                            alt="NT"
                                                        />
                                                    ) : null}
                                                    {sta.orderType &&
                                                    sta.orderType.includes(
                                                        'Account Default Tissue'
                                                    ) ? (
                                                        <img
                                                            style={{
                                                                marginLeft:
                                                                    sta.orderType.includes(
                                                                        'Account Default Non Tissue'
                                                                    )
                                                                        ? '4px'
                                                                        : '0',
                                                            }}
                                                            src={TissueItemIcon}
                                                            alt="T"
                                                        />
                                                    ) : null}
                                                </span>
                                            </span>
                                        </AccountDefaultMobile>
                                    )}
                                </OrderDefaultsGrid>
                            </BodyGridContainer>
                        );
                    })}
            </OrderDetailTabBodyContainer>
            <Footer>
                <BottomNavigation
                    opacity={'1'}
                    border={'1px solid #1010EB'}
                    // borderRadius={
                    //     window.innerWidth <= sizes.mobileDevice
                    //         ? 'none'
                    //         : '25px'
                    // }
                    position={'absolute'}
                    portraitposition={'fixed'}
                    padding={
                        // shipToAddressEdit || isCancel
                        //     ? '11px 50px !important' :

                        '11px 20px !important'
                    }
                    justifyContent={window.innerWidth >= sizes.mobileDevice ? 'flex-end' : 'center'}
                    moblieJustifyContent={'center'}
                    bottom={window.innerWidth === 820 ? '65px' : '0px'}
                    ship_to_page={true}
                    left={'0'}
                    right={'0'}
                >
                    {employeeRole !== FIM_USER_ROLE &&
                        employeeRole !== ITA_USER_ROLE &&
                        employeeRole !== FIA_USER_ROLE &&
                        shipToAddress && (
                            <Button
                            id={'accounts-shipToAddress-editButton'}
                                show={shipToAddressEdit ? false : true}
                                // primary={true}
                                variant={ButtonStyles?.primary}
                                top={'659px'}
                                left={'670px'}
                                width={'260px'}
                                height={'38px'}
                                clicked={onEdit}
                                margin={isIpad ? '0px 0px 0px 0px' : '0px'}
                            >
                                <TextBold color={'#FFFFFF'}>
                                    {t('accounts.shipToAddress.edit')}
                                </TextBold>
                            </Button>
                        )}
                    {shipToAddressEdit ? (
                        <>
                            <Button
                            id={'accounts-shipToAddress-cancelButton'}
                                show={true}
                                // secondary={true}
                                variant={ButtonStyles?.secondary}
                                border={'1px solid #140F4B'}
                                top={'659px'}
                                left={'670px'}
                                width={'131px'}
                                mobileWidth={'160px'}
                                height={'38px'}
                                margin={
                                    window.innerWidth <= sizes.mobileDevice
                                        ? '0px 6px 0px 0px'
                                        : '0px 20px 0px 0'
                                }
                                clicked={onCancel}
                            >
                                <TextBold color={'#140F4B'}>
                                    {t('accounts.accountDetailCard.cancel')}
                                </TextBold>
                            </Button>

                            <Button
                            id={'accounts-shipToAddress-saveButton'}
                                show={true}
                                // primary={true}
                                variant={ButtonStyles?.primary}
                                top={'659px'}
                                left={'670px'}
                                width={'131px'}
                                mobileWidth={'160px'}
                                height={'38px'}
                                clicked={onSave}
                            >
                                <TextBold color={'#FFFFFF'}>
                                    {t('accounts.shipToAddress.save')}
                                </TextBold>
                            </Button>
                        </>
                    ) : null}
                </BottomNavigation>
                {isCancel ? (
                    <UnsavedChanges
                        onDiscard={handleDiscardChanges}
                        onClose={handleSaveAndExit}
                        continueText={t('more.common.conedit')}
                        fromSettingsClose={fromSettingsClose}
                    />
                ) : null}
            </Footer>
        </>
    );
};
export default ShipToAddress;
